module.exports = {
	bankServiceChargeGroupCode	: 80,
};